
import XButton from 'vux/src/components/x-button/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import Card from 'vux/src/components/card/index.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'

import $ from 'jquery';
export default {
components: {
XButton,
XHeader,Divider, Card,CheckIcon
},
data () {
return {
showdata:false,
taxData:{ },
attention:"",
showNodata:false,
showRouter:false,
readed:false,
}
},
created() {
this.$vux.loading.show({
text: '数据加载中',
})



this.getReport();
},
methods:{
shengao(){
var _this=this;
this.$vux.confirm.show({

title:"确定提交申告吗？",
content:"提交申告将会扣除"+_this.taxData.fee+"日元手续费",
onCancel () {
},
onConfirm () {
_this.$vux.loading.show({
text: '正在提交',
})
let loginData=JSON.parse(localStorage.getItem("loginData"));
let accessToken=loginData.access_token;
let token=loginData.token_type+" "+loginData.access_token;
$.ajax({
url : _this._Api.report,
type: "POST",
contentType: "application/json;charset=utf-8",
data:JSON.stringify({
"id":_this.taxData.id
}),
beforeSend: function(xhr) {
xhr.setRequestHeader("Authorization", token);
},
success: function(res) {

_this.$vux.loading.hide();
_this.$vux.toast.show({
text: '提交成功'
})
setTimeout(() => {
location.reload();
}, 1000)

},

error:function(res){
_this.$vux.loading.hide();
_this.$vux.toast.text(
'发生错误，稍后重试'
)

}

});
}
})
},
backHome(){
this.$router.push({
path: '/home'
});
},
getReport(){
var that=this;
let owner=JSON.parse(localStorage.getItem("ownerData"));
if(owner && owner.ownerId){
this.BM.JQajax({
url:this._Api.report,
method:"GET",
success: function(data) {
if(data.data){
that.taxData=data.data;
}else{
that.taxData={}
that.attention=data.msg;
if(data.msg.indexOf("税务计算")!=-1){

that.showRouter=true;
}else{
that.showRouter=false;
}
}
that.$vux.loading.hide();
that.showdata=true;

},
error:function(data){
that.$vux.loading.hide();
that.$vux.toast.text(
'暂无权限，如是房主请咨询您的投资顾问'
)
that.showdata=false;
that.showNodata=true;
},
unAuth:function(){
localStorage.removeItem('loginData');
that.$router.push({
path: '/'
});
}
})
}else{
that.$vux.loading.hide();
that.showdata=false;
that.showNodata=true;
}
},
}
}



// WEBPACK FOOTER //
// ./src/pages/taxesList.vue